// NOTE: please keep this JSON config sorted alphabetically to keep consistency between region config files

import {
  PaymentMethod,
  SUPPORTED_COUNTRY,
  SUPPORTED_LANGUAGE,
  MaxAgeExpiration,
} from 'utils/constants';
import { OrderSearchOperationName } from 'ui/forms/OrderLookUp/types';
import { commonConfig } from 'sites/common/config';

import { SiteConfig } from '../types';

import { INForms } from './forms';
import { INFieldProps } from './fields';
import { inStates } from './states';

export const config: SiteConfig = {
  ...commonConfig,
  addressCountries: [{ label: 'India', value: SUPPORTED_COUNTRY.IN }],
  addressSearch: {
    billing: ['IN'],
    shipping: ['IN'],
  },
  addressStates: { IN: inStates },
  analytics: { releaseVersion: `India | ${process.env.VERSION}` },
  applePaySupportedNetworks: [],
  badgeIdsExcludedBySaleStatus: [],
  bloomreach: {
    objectName: 'br_data',
    viewId: 'in',
  },
  branchAnalyticsData: {
    agencyId: '1000067495857508873',
  },
  charactersNeededToSubmitSearch: 3,
  countryCode: 'in',
  countryName: 'India',
  currency: {
    code: 'INR',
    decimalsToDisplay: 0,
    symbol: '₹',
  },
  fieldProps: INFieldProps,
  flag: '🇮🇳',
  forms: { ...INForms },
  insiderIntegration: {
    partnerId: '10006083',
    partnerName: 'pumaindia',
  },
  maxAgeCookiesExpires: MaxAgeExpiration.WEEKLY,
  maxCountRecordKeeper: 0,
  myAccountDashboardConfiguration: [
    {
      childOrder: [
        'profileComponent',
        'passwordComponent',
        'phoneComponent',
        'preferencesComponent',
        'ambassadorComponent',
      ],
      name: 'leftColumn',
    },
    {
      childOrder: ['addressBookComponent', 'orderHistoryComponent'],
      name: 'rightColumn',
    },
  ],
  orderLookUpQuery: OrderSearchOperationName['SearchOrderByPhone'],
  orderedPaymentPartners: [
    'visa',
    'master',
    'maestro',
    'americanExpress',
    'UPI',
    'rupay',
  ],
  paymentMethodsMixedWithGiftCard: [],
  pixleeId: {
    en: '2106280',
  },
  priceInputMaxLength: 5,
  priceSliderInterval: 500,
  pumaAppDownloadUrl: 'https://app.puma.com/web-download-in',
  region: 'asia',
  regionCode: 'IND',
  savedCreditCardTemplate: ['new', 'saved'],
  searchEngineIndexableLanguages: [SUPPORTED_LANGUAGE.EN],
  searchSymbolsMinValue: 3,
  selectablePaymentMethods: [
    PaymentMethod.RAZORPAY,
    PaymentMethod.UPI,
    PaymentMethod.UPI_COLLECT,
    PaymentMethod.SCHEME,
    PaymentMethod.NET_BANKING_DEPRECATED,
    PaymentMethod.ONLINE_BANKING_IN,
    PaymentMethod.WALLET,
    PaymentMethod.PAYTM,
    PaymentMethod.COD,
  ],
  staticFeatures: {
    ...commonConfig.staticFeatures,
    allowGuestAccessToOrderDetails: true,
    canRemoveWishlistItemsFromPDP: true,
    displayPromoDiscountBreakdown: false,
    enableItemLinksInCartSummary: true,
    enableModelMeasurements: true,
    hideEmailNotifications: true,
    hidePickUpWhereYouLetOff: true,
    hideWeightInProductMeasurements: true,
    personalizationEnabled: true,
    popoverLoginEnabled: true,
    productFilterCollapsible: false,
    returnsOnOrderDetailsPage: true,
    searchLocalImagesOnProductComparison: true,
    showAddAddressButtonInAccountDashboard: false,
    showCookieBanner: true,
    showFinancialIncentivesLink: false,
    showFreeShippingCost: true,
    showHeaderSubHeaderProductDetail: false,
    showModifiedResetPassFormPopup: false,
    showPaymentPartnersInFooter: true,
    showPhoneInCheckout: false,
    showPinterestFooterIcon: true,
    showPriceDifference: true,
    showPromoExclusionMsgAboveProductDetails: true,
    showPromoExclusionMsgInBaseSize: true,
    showSaleBadgeOnProductImageEnabled: true,
    singInInConfirmationForm: false,
    showCookieConsentLayer: true,
    useNewPaymentForm: true,
    useProductSizeChart: true,
    isSalesfloorEnabled: true,
    otpLoginEnabled: true,
  },
  supportedLocales: ['en-in'],
  validation: {
    address: {
      length: commonConfig.validation.address.length,
      line1: '^[a-zA-Z0-9-\\/#., \\\\]*$',
      line2: '^[a-zA-Z0-9-\\/#., \\\\]*$',
      title: '^[a-zA-Z0-9 ]*$',
    },
    email: '^[\\w.%+-]+@[\\w.-]+\\.[\\w]{2,6}$',
    name: {
      length: commonConfig.validation.name.length,
      regex: '^[a-zA-Z]+(?: [a-zA-Z]+)*$',
    },
    orderNo: '^(?:\\d{8,9}|INSTG\\d{8})$',
    password:
      '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-!@#$%^&*.+(){}~?])(?=.{8,})',
    phone: {
      length: {
        max: 13,
        min: commonConfig.validation.phone.length.min,
      },
      prefix: '+91',
      regex: '^\\+91[0-9]{10}$',
    },
    postalCode: {
      IN: '^[1-9][0-9]{5}$',
    },
  },
};
